import { motion } from "framer-motion";
import { Package2 } from "lucide-react";
import { COMMODITIES } from "@/data/content";

export default function Commodities() {
  return (
    <section
      id="commodities"
      data-testid="commodities-section"
      className="border-b border-[#E4E7EC] bg-[#F9FAFB]"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="overline mb-4">§ 06 — Cargo types</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
              Cargo we <span className="text-[#D92D20]">specialise</span> in.
            </h2>            <p className="mt-6 max-w-md text-base leading-relaxed text-[#475467]">
              We clear <strong className="text-[#101828]">any commodity</strong> that is
              legally importable into India — from a single semiconductor chip
              to a full container of industrial machinery. The categories below
              are simply where we handle the highest volumes and have deepest
              HSN precision. If your cargo isn't listed, ask us anyway.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 gap-0 border-2 border-[#101828] md:grid-cols-2">
              {COMMODITIES.map((c, i) => (
                <motion.div
                  key={c.name}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.4, delay: i * 0.04 }}
                  className={`bg-white p-6 ${
                    i % 2 === 0 ? "md:border-r md:border-[#101828]" : ""
                  } ${i < COMMODITIES.length - 2 ? "border-b border-[#101828]" : "border-b border-[#101828] md:border-b-0"}`}
                  data-testid={`commodity-${i}`}
                >
                  <div className="flex items-center gap-3">
                    <Package2 className="h-5 w-5 text-[#D92D20]" strokeWidth={2.5} />
                    <h3 className="font-display text-lg font-bold tracking-tight text-[#101828]">
                      {c.name}
                    </h3>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-[#475467]">
                    {c.detail}
                  </p>
                </motion.div>
              ))}
            </div>
            <div
              className="mt-4 border-2 border-[#101828] bg-[#FDB022] p-5"
              data-testid="any-commodity-callout"
            >
              <p className="font-mono-accent text-[#101828]">
                + ANY OTHER COMMODITY
              </p>
              <p className="mt-2 text-sm leading-relaxed text-[#101828]">
                <strong>We clear any commodity that is legally importable into India.</strong>{" "}
                Perishables, chemicals, defence-approved cargo, live animals,
                works of art, e-waste, DGR, EPCG-linked machinery, project
                cargo, gems &amp; jewellery, wines &amp; spirits, spare parts,
                packaged food, cosmetics, industrial samples — if the HSN
                exists, we file it. Send us your product description and we'll
                classify and quote within the hour.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
